import { render, staticRenderFns } from "./account-part-add-or-update.vue?vue&type=template&id=ad842f4e&scoped=true"
import script from "./account-part-add-or-update.vue?vue&type=script&lang=js"
export * from "./account-part-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./account-part-add-or-update.vue?vue&type=style&index=0&id=ad842f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad842f4e",
  null
  
)

export default component.exports